import { render, staticRenderFns } from "./video-player.vue?vue&type=template&id=4538140e&scoped=true"
import script from "./video-player.vue?vue&type=script&lang=js"
export * from "./video-player.vue?vue&type=script&lang=js"
import style0 from "./video-player.vue?vue&type=style&index=0&id=4538140e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../mnt/host/d/wwwroot/deepcityAI/user-client-pc/user-client-common-pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4538140e",
  null
  
)

export default component.exports